import { Container } from '@bit/ui-common.ui-components/ss-components';
import * as helpServices from '../../../redux/services/helpServices';
import { Modal, Button } from 'antd';
import Faqs from './Faqs';

export default Container({ 
    state: s => ({ helpData: s.helpData }), 
    services: [ helpServices ] 
}, class FaqModal extends React.Component {
    constructor(props) { super(props); }
    render() {
        const 
        { toggleHelpFaqModal } = this.props.services,
        { showFaqModal } = this.props.helpData;

        return (
            <div>
                <Modal 
                    visible={showFaqModal} 
                    closable={false}
                    footer={null}
                    width='auto'
                    style={{ position: 'fixed', top: '-100%' }}
                >
                    <div>
                        <Button 
                            size='small'
                            icon='close-circle-o'
                            style={{ 
                                borderRadius: '20px',
                                position: 'fixed',
                                top: '38px',
                                width: '80px',
                                zIndex: '2',
                                right: '10.5%'
                            }}
                            onClick={() => toggleHelpFaqModal()}
                        >
                            {'Close'}
                        </Button>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <Faqs 
                            space='popover'
                            theme='dark'
                            portal='c'
                            format='default'
                        />
                    </div>
                </Modal>
            </div>
        )
    }
});